<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <el-button
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <div class="data-display-wrapper">
        <div class="img-display-wrapper">
          <div class="data-categories">
            <label style="font-size:14px;">层次:</label>
            <label-switch
              v-model="category"
              :options="categories"
              style="height:2rem;line-height:1.5rem;"
              @change="onCategoryChange"
            />
          </div>
          <img-player v-model="imgSrc" :img-infos="reverseImgInfos" />
        </div>

        <data-time-switch v-model="imgSrc" :options="imgInfos" />
      </div>
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseNMC from '../BaseNMC'
import LayoutContent from '../../../../../components/Layout/Content'
import DataTimeQuery from '../../../../../components/Data/Query/DataTimeQuery'
import LabelSwitch from '../../../../../components/LabelSwitch/index'
import DataWrapper from '../../../../../components/Data/DataWrapper'
import DataTimeSwitch from '../../../../../components/DataTimeSwitch'
import ImgPlayer from '../../../../../components/ImgPlayer'

export default {
  name: 'Precipitation',
  routeInfo: {
    label: '降水量分析',
    icon: 'fa fa-users'
  },
  extends: BaseNMC,
  components: {LayoutContent, DataTimeQuery, LabelSwitch, DataWrapper, ImgPlayer, DataTimeSwitch},
  computed: {
    type: () => 3
  }
}
</script>

<style lang="scss" scoped>
.data-display-wrapper {
  display: grid;
  grid-template-columns: auto max-content;
  grid-column-gap: 1rem;
  width: 100%;
  height: 100%;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }
}

.img-display-wrapper {
  display: grid;
  grid-template-rows: max-content auto;
  grid-row-gap: 1rem;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }
}

.data-categories {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: .5em;
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/01Meteorological/06Precipitation/index.vue